<template>
	<transition name="dialog">
		<div class="dialog-mask" @click="close()" v-show="showing">
			<div class="dialog-wrapper">
				<div class="dialog-container" @click.stop>
					<header class="dialog-header">
						<h5>{{merged.title}}</h5>
					</header>
					<article class="dialog-content">
						<span v-html="merged.message"></span>
					</article>
					<footer class="dialog-footer">
						<a class="mdc-button mdc-button--dense" @click="close()">{{merged.cancelText}}</a>
						<a class="mdc-button mdc-button--primary" @click="confirm()" v-if="merged.confirm">{{merged.confirmText}}</a>
					</footer>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import Vue from 'vue'

	const suppressWarn = Vue && Vue.version.indexOf('1.') === 0 ? { 'transition': { template: '<div><slot></slot></div>' } } : null

	const DEFAULTS = {
		id: 'dialog',
		className: '',
		parent: 'body',
		transition: 'dialog',
		title: 'Alert',
		message: 'Look here',
		cancelText: 'close',
		confirmText: 'Confirm',
	}

	export default {
		name: '',
		data () {
			return {
				queue: [],
				option: {},
				showing: false,
			}
		},
		components: suppressWarn,
		computed: {
			merged: function ()
			{
				return Object.assign({}, DEFAULTS, this.option)
			},
		},
		methods: {
			close ()
			{
				this.queue.shift()
			},
			confirm ()
			{
				if( this.merged.confirm ) {
					this.merged.confirm()
					this.queue.shift()
				}
			},
		},
		watch: {
			queue : function ()
			{
				let pending = this.queue.length
				if( !pending ) {
					this.showing = false
					return
				}
				this.showing = true
				this.option = this.queue[0]
			},
		},
	}
</script>

<style scoped lang="scss">

	@import '@material/button/mdc-button';


	.mdc-button {
		font-size: rem(16px);
		will-change: opacity;

		&--primary {
			will-change: opacity, color !important;
		}
	}

	$easing-dialog: cubic-bezier(0.25, 0.8, 0.25, 1);
	$easing-standard: cubic-bezier(0.4, 0.0, 0.2, 1);

	.dialog {
		&-mask {
			animation-fill-mode: forwards;
			background-color: rgba(0,0,0,0.2);
			height: 100%;
			left: 0;
			position: fixed;
			top: 0;
			width: 100%;
			z-index: 999;
		}

		&-wrapper {
			align-items: center;
			animation-fill-mode: forwards;
			display: flex;
			flex-direction: column;
			justify-content: center;
			position: relative;
			height: 100%;
			width: 100%;
		}


		&-container {
			background-color: white;
			border-radius: 4px;
			box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			min-width: 240px;
			max-height: 90%;
			max-width: 90%;
			overflow-y: auto;
		}

		&-header {
			align-items: center;
			border-bottom: 1px solid color_('background');
			display: flex;
			justify-content: space-between;
			padding: 0 1rem;
		}

		&-content {
			box-sizing: border-box;
			flex: 1;
			font-size: rem(24px);
			overflow-x: hidden;
			overflow-y: auto;
			padding: 2rem;
		}

		&-footer {
			align-items: center;
			display: flex;
			justify-content: space-between;
			padding: 1rem;
		}

		&-enter-active {
			animation: dialogIn 500ms $easing-dialog;

			.dialog-wrapper {
				animation: scaleIn 333ms $easing-standard;
			}
		}

		&-leave-active {
			animation: dialogOut 350ms $easing-dialog;

			.dialog-wrapper {
				animation: scaleOut 350ms $easing-standard;
			}
		}
	}

	@keyframes dialogIn {
		0% {
			background-color: rgba(0,0,0,0);
		}

		100% {
			background-color: rgba(0,0,0,0.2);
		}
	}

	@keyframes dialogOut {
		0% {
			background-color: rgba(0,0,0,0.2);
		}

		100% {
			background-color: rgba(0,0,0,0);
		}
	}

	@keyframes scaleIn {
		0% {
			transform: translate3d(0,100vh,0) scale(0);
			visibility: visible;
		}

		100% {
			transform: translate3d(0,0,0) scale(1);
		}
	}

	@keyframes scaleOut {
		0% {
			transform: translate3d(0,0,0) scale(1);
			visibility: visible;
		}

		100% {
			transform: translate3d(0,100vh,0) scale(0);
			visibility: hidden;
		}
	}
</style>


// WEBPACK FOOTER //
// src/lib/dialog/Dialog.vue